import * as theme from "./theme.css";

interface DrawerHeaderLabelProps {
    label: string;
}
export function DrawerHeaderLabel({ label }: DrawerHeaderLabelProps) {
    return <span className={theme.label}>{label}</span>;
}
